export default "__VITE_ASSET__aa64a59b__"